import Track from '../../v2/utils/tracking';

const AdyenV2CheckoutLazyLoader = () => import(
  /* webpackChunkName: "AdyenV2Checkout" */
  '@adyen/adyen-web'
).then(AdyenV2Checkout => AdyenV2Checkout)
  .catch((error) => {
    Track.error(`Failed to load @adyen/adyen-web ${error}`);
  });
export default AdyenV2CheckoutLazyLoader;
